import { Lock } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";

export default function ViewMgtDeviceConfigLock({ configuration }: { deviceId?: string | null | undefined, device?: any | undefined | null, configuration?: any | undefined | null }) {
  
  return (
    <ViewMgtDevicePanel title="Lock" icon={<Lock size={16} />} fullWidth collapsible collapsed>
      <div className="grid grid-cols-1 gap-0">
        ...
      </div>
    </ViewMgtDevicePanel>
  );
}